var $ = require('../internals/export');

var fill = require('../internals/array-fill');

var addToUnscopables = require('../internals/add-to-unscopables'); // `Array.prototype.fill` method
// https://tc39.github.io/ecma262/#sec-array.prototype.fill


$({
  target: 'Array',
  proto: true
}, {
  fill: fill
}); // https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables

addToUnscopables('fill');